module.exports = __webpack_public_path__ + "static/media/statistics-completed.2dcd91c5.svg";